/**
 * App-wide constants: form field limits, network request states, and a few shared values.
 */

/**
 * Lowest allowed delivery-requirements unload weight at checkout
 * (`Checkout/ShippingAndBilling/Form/DeliveryRequirementsForm.tsx`), inclusive.
 */
export const minUnloadWeight = 100;
/**
 * Highest allowed unload weight in the same checkout field, inclusive; pairs with
 * `minUnloadWeight`.
 */
export const maxUnloadWeight = 999999;
/** `maxLength` of the company-name input in checkout, account settings and the address modals. */
export const maxCompanyName = 40;
/** `maxLength` of the discount-code input (`Shared/PurchaseOrderDiscountCode`). */
export const maxDiscountCodeLength = 10;
/**
 * `maxLength` of the business-address input in the credit application
 * (`CompanyInformation.tsx`).
 */
export const maxAddressLineLength = 40;
/** City-field length limit; no input uses it. */
export const maxCityLength = 40;
/**
 * `maxLength` of first-name inputs in checkout, account settings, user management, the address
 * modals, and the credit and onboarding forms.
 */
export const maxFirstNameLength = 20;
/** `maxLength` of last-name inputs, in the same forms as `maxFirstNameLength`. */
export const maxLastNameLength = 20;

/**
 * The result of a network operation
 */
export enum NetworkOperationResult {
	/**
	 * Request has not been made (default)
	 */
	IDLE = "idle",
	/**
	 * Request made, pending response from server
	 */
	PENDING = "pending",
	/**
	 * Server responds with success
	 */
	SUCCESS = "success",
	/**
	 * Server responds with error
	 */
	ERROR = "error",
}

/**
 * Prefix of the client-generated id (`TC:<random>`) that
 * `Shared/CreditCard/AddCreditCard/AddCreditCardModal.tsx` gives a card that is not posted to
 * the saved-cards route. The edit-card modal and slider check for it.
 */
export const TempCreditCard = "TC";

/** Contact-us path, resolved against the current origin (the marketing site's page on the web). */
export const contactUsUrl = "/contact-us";
